<template>
  <div>
    <v-card elevation="5">
      <v-toolbar color="primaryLight" dark dense>
        <v-toolbar-title>Sectores</v-toolbar-title>

        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn fab small v-bind="attrs" v-on="on" color="secondary" bottom right absolute :disabled="isIncendioFinalizado || disabledByRol" @click="showGestionSectores = true">
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar sectores</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text
        style="flex-grow: 1;
  overflow: auto;"
      >
        <v-btn-toggle v-model="sectoresSelected" color="primary" rounded multiple>
          <v-btn :key="i" v-for="(sector,i) in sectoresEmergencia" small>{{ sector.SECTOR }}</v-btn>
        </v-btn-toggle>
      </v-card-text>
    </v-card>

    <vx-dialog-gestion-sectores :show="showGestionSectores" :idEmergencia="idEmergencia" @close="showGestionSectores = false" /> <!-- @cancelar="showGestionSectores = false" @aceptar="saveSectores" -->
  </div>
</template>

<script>
import DialogGestionSectores from './DialogGestionSectores'

export default {
  components: {
    'vx-dialog-gestion-sectores': DialogGestionSectores
  },

  props: {
    idEmergencia: String
  },

  data: () => ({
    sectoresSelected: [],
    showGestionSectores: false
  }),

  computed: {
    emergencia () {
      return this.$store.getters['emergencia/getEmergenciaByID'](this.idEmergencia)
    },

    isIncendioFinalizado () {
      return this.$store.getters['incendio/isIncendioFinalizado'](this.idIncendio)
    },

    sectoresEmergencia () {
      let sectores = []

      if (this.emergencia) {
        sectores = this.emergencia.SECTORES
      }

      return sectores
    },
    disabledByRol () {
      // Deshabilita funciones dependiendo del rol
      return !this.$store.getters['usuario/isCurrentUsuarioAdmin']
    }
  },

  watch: {
    idEmergencia () { // Al abrir, seleccionar todos
      this.sectoresSelected = []
      if (this.idEmergencia) {
        for (let i = 0; i < this.sectoresEmergencia.length; i++) {
          this.sectoresSelected.push(i)
        }
      }
    },

    sectoresSelected () {
      this.$emit('changeSectoresSelected', this.sectoresSelected)
    }
  },

  methods: {
    saveSectores (sectores) {
      this.showGestionSectores = false
      this.$store.dispatch('emergencia/changeSectoresEmergencia', {
        ID_EMERGENCIA: this.idEmergencia,
        SECTORES: sectores
      })
    }
  }
}
</script>

<style scoped>
</style>
